import React, { Component } from "react";
import { connect } from "react-redux";
import "../../assets/css/login.css";
import SelectJenjang from "./components/SelectJenjang";
import SelectSchool from "./components/SelectSchool";
import axiosInstance from "../../store/services/AxiosService";
import { getDataStudent, userLogout, deleteScheduleActive } from "../../store/actions/index";
import { FailureMessageStudent, FailureMessageUserLogin } from "./components/ErrorMessage.jsx";
import queryString from 'query-string';
import * as loadingAnimation from '../../assets/lottie/loading.json'
import * as loadingAnimationStudent from '../../assets/lottie/student.json'
import lottie from 'lottie-web'

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bypass: false,
            nisn: "",
            password: "",
            listSchool: [],
            listSchoolByDegree: [],
            degreeSelected: null,
            schoolSelected: null,
            loadingAuth: false,
            responseLoginFailed: null,
            showPassword: false,
            hasSchoolFromUrl: false,
            schoolNameFromUrl: "",
            schoolDegreeFromUrl: "",
            loadingSchoolFromUrl: false,
        };
    }
    
    componentDidMount() {
        const params = queryString.parse(window.location.search);
        const schoolId = params.school_id || params.school;

        if (params.s) {
            this.handleBypassLogin(params.s, params.url);
        } else if (schoolId) {
            this.loadSchoolFromUrl(schoolId);
        } else {
            this.fetchDegreeList();
        }

        lottie.loadAnimation({
            container: document.getElementById('animationStudent'),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: loadingAnimationStudent.default,
        });
    }

    loadSchoolFromUrl = (schoolId) => {
        this.setState({ loadingSchoolFromUrl: true });
        axiosInstance
            .get(`/schools/${schoolId}`)
            .then((res) => {
                const school = res.data;
                if (school && school.id) {
                    const data = {
                        api_url: school.api_url,
                        label: school.api_name,
                        value: school.id,
                        degree: school.degree
                    };
                    this.setState({
                        schoolSelected: data,
                        hasSchoolFromUrl: true,
                        schoolNameFromUrl: school.api_name,
                        schoolDegreeFromUrl: school.degree,
                        loadingSchoolFromUrl: false,
                    });
                } else {
                    this.fallbackToManualSchool("Data sekolah dari link tidak ditemukan.");
                }
            })
            .catch((err) => {
                console.error("Gagal mengambil data sekolah dari link:", err);
                this.fallbackToManualSchool("Gagal memuat sekolah dari tautan ini. Silakan pilih secara manual.");
            });
    };

    fetchDegreeList = () => {
        axiosInstance
            .get(`/schools/get/degree`)
            .then((res) => {
                let arrListDegree = [];
                Object.values(res.data).map((item) => arrListDegree.push(item));
                this.setState({ listSchool: arrListDegree, loadingSchoolFromUrl: false });
            })
            .catch((error) => {
                console.error("Gagal mengambil data jenjang:", error);
                this.setState({ loadingSchoolFromUrl: false });
            });
    };

    fallbackToManualSchool = (alertMsg = null) => {
        if (alertMsg) {
            alert(alertMsg);
        }
        this.setState({
            hasSchoolFromUrl: false,
            schoolNameFromUrl: "",
            schoolDegreeFromUrl: "",
            schoolSelected: null,
            loadingSchoolFromUrl: false,
        });
        this.fetchDegreeList();
    };

    handleBypassLogin(student_id, api_url) {
        const url = `/schools/get/url?api_url=${api_url}`;
        this.setState({ bypass: true })
        axiosInstance
            .get(url)
            .then((response) => {
                const { api_url, api_name, id } = response.data
                const data = {
                    api_url: api_url,
                    label: api_name,
                    value: id
                }
                this.handleSelectSchool(data)
                this.login(student_id);
            }).catch(err => {
                alert("Data sekolah tidak ditemukan")
            });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({ responseLoginFailed: null, loadingAuth: true });
        this.login();
    };

    // FUNGSI HANDLE ERROR YANG SUDAH DIPERBAIKI
    handleErrorResponse = (error) => {
        let errorMessage = "Terjadi kesalahan pada server. Silakan coba lagi.";
        
        if (error.response && error.response.data) {
            // Jika backend membalas dengan JSON yang rapi { message: "..." }
            if (error.response.data.message) {
                errorMessage = error.response.data.message;
            } 
            // Jika backend membalas dengan string langsung
            else if (typeof error.response.data === 'string') {
                errorMessage = error.response.data;
            }
            // Jika backend membocorkan transferStats Guzzle (Kasus Anda sebelumnya)
            else if (error.response.data.response && error.response.data.response.transferStats) {
                errorMessage = "Login ditolak oleh Server Ujian. Pastikan ujian sudah aktif.";
            }
        }

        this.setState({
            loadingAuth: false,
            responseLoginFailed: FailureMessageUserLogin(errorMessage),
        });
        window.alert(errorMessage);
    }

    login(student_id = null) {
        const isBypass = this.state.bypass;
        const url = isBypass ? `/users/student/${student_id}/school/${this.state.schoolSelected.value}` : `/users/student/school/${this.state.schoolSelected.value}/login`;
        
        if (!isBypass) {
            const dataToPost = {
                nisn: this.state.nisn,
                password: this.state.password,
            };
            axiosInstance
                .post(url, dataToPost)
                .then((response) => {
                    if (response.data.status === true) {
                        this.props.getDataStudent(response.data, this.state.schoolSelected);
                        this.setState({ loadingAuth: false });
                        this.props.history.push("/student");
                    } else {
                        this.setState({
                            loadingAuth: false,
                            responseLoginFailed: FailureMessageStudent(),
                        });
                    }
                })
                .catch((error) => {
                    // Panggil fungsi handle error yang baru
                    this.handleErrorResponse(error);
                });
        } else {
            axiosInstance
                .get(url)
                .then((response) => {
                    if (response.data.status === true) {
                        this.props.getDataStudent(response.data, this.state.schoolSelected);
                        this.setState({ loadingAuth: false });
                        this.props.history.push("/student");
                    } else {
                        this.setState({
                            loadingAuth: false,
                            responseLoginFailed: FailureMessageStudent(),
                        });
                    }
                })
                .catch((error) => {
                    // Panggil fungsi handle error yang baru
                    this.handleErrorResponse(error);
                });
        }
    }

    handleInputNisn = (e) => {
        e.preventDefault();
        this.setState({
            nisn: e.target.value,
            responseLoginFailed: null,
        });
    };

    handleInputPassword = (e) => {
        e.preventDefault();
        this.setState({
            password: e.target.value,
            responseLoginFailed: null,
        });
    };

    handleSelectDegree = (degree) => {
        this.state.listSchool.forEach((item) => {
            if (item.value === degree) {
                this.setState({
                    degreeSelected: degree,
                    listSchoolByDegree: item.schools,
                    schoolSelected: null,
                });
            }
        });
    };

    handleSelectSchool = (school) => {
        this.setState({ schoolSelected: school });
    };

    render() {
        const isBypass = this.state.bypass;

        if (isBypass && this.state.responseLoginFailed === null) {
            lottie.loadAnimation({
                container: document.getElementById('animation_student'),
                renderer: 'svg',
                loop: true,
                autoplay: true,
                animationData: loadingAnimation.default,
            })
        }

        return (
            <div className="container" style={{ minHeight: "100vh" }}>
                <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
                    <div className="card-login align-self-center  w-100" style={{ minHeight: "450px" }}>
                        <div className="row" style={{ height: "100%" }}>
                            <div className="col-sm d-flex align-items-center justify-content-center box-img-login">
                                <div id="animationStudent" className="img-landing-login align-self-center " style={{ width: "85%", display: "inline-flex" }}></div>
                            </div>
                            <div className="col-sm pt-2">
                                <div className="auth-form-light text-center p-4">
                                    {
                                        !isBypass ? (
                                            <div>
                                                <h4>Hai Siswa{this.state.schoolNameFromUrl ? ` - ${this.state.schoolNameFromUrl}` : ""}, Apa kabar?</h4>
                                                <h6 className="font-weight-light">Masuk untuk lanjut</h6>

                                                {/* Tampilkan indikator loading jika sedang fetch sekolah dari URL */}
                                                {this.state.loadingSchoolFromUrl && (
                                                    <div className="my-4 text-center">
                                                        <i className="mdi mdi-loading mdi-spin text-primary" style={{ fontSize: "2rem" }}></i>
                                                        <p className="text-muted mt-2">Memuat data sekolah...</p>
                                                    </div>
                                                )}

                                                {/* Jika TIDAK memakai URL khusus, tampilkan dropdown pilihan jenjang & sekolah manual */}
                                                {!this.state.hasSchoolFromUrl && !this.state.loadingSchoolFromUrl && (
                                                    <>
                                                        <div className="mt-3">
                                                            <SelectJenjang onSelectDegree={this.handleSelectDegree} listSchool={this.state.listSchool} />
                                                        </div>
                                                        {this.state.degreeSelected !== null ? (
                                                            <div className="mt-3">
                                                                <SelectSchool onSelectSchool={this.handleSelectSchool} listSchoolByDegree={this.state.listSchoolByDegree} />
                                                            </div>
                                                        ) : null}
                                                    </>
                                                )}

                                                {/* Form input NISN & Password langsung muncul jika sekolah sudah terpilih */}
                                                {this.state.schoolSelected !== null && !this.state.loadingSchoolFromUrl ? (
                                                    <form className="pt-3" onSubmit={this.handleSubmit}>
                                                        <div className="form-group">
                                                            <input type="text" className="form-control" id="nisn" placeholder="NISN" style={{ fontSize: "1rem" }} required onChange={this.handleInputNisn} />
                                                        </div>
                                                        <div className="form-group" style={{ marginTop: '20px', position: 'relative' }}>
                                                            <input id="passwordUser" placeholder="Password"
                                                                type={this.state.showPassword ? "text" : "password"}
                                                                className="form-control"
                                                                style={{
                                                                    fontSize: "1rem",
                                                                    paddingRight: '45px',
                                                                }}
                                                                required onChange={this.handleInputPassword}
                                                            />
                                                            <i
                                                                className={this.state.showPassword ? "mdi mdi-eye-off" : "mdi mdi-eye"}
                                                                onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                                                                style={{
                                                                    position: 'absolute',
                                                                    right: '15px',
                                                                    top: '50%',
                                                                    transform: 'translateY(-50%)',
                                                                    cursor: 'pointer',
                                                                    fontSize: '20px',
                                                                    color: '#666',
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="mt-3">
                                                            <button type="submit " className="btn btn-lg btn-gradient-primary" style={{ width: "100%" }}>
                                                                {this.state.loadingAuth === true ? (
                                                                    <div>
                                                                        <i className="mdi mdi-loading mdi-spin"></i> Masuk{" "}
                                                                    </div>
                                                                ) : (
                                                                    "Masuk"
                                                                )}
                                                            </button>
                                                            {this.state.responseLoginFailed}
                                                        </div>

                                                        {/* Fallback option jika siswa ingin berganti sekolah */}
                                                        {this.state.hasSchoolFromUrl && (
                                                            <div className="mt-3 text-center">
                                                                <small className="text-muted">
                                                                    Bukan dari sekolah ini?{" "}
                                                                    <a
                                                                        href="#manual"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            this.fallbackToManualSchool();
                                                                        }}
                                                                        style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
                                                                    >
                                                                        Pilih sekolah lain
                                                                    </a>
                                                                </small>
                                                            </div>
                                                        )}
                                                    </form>
                                                ) : null}
                                            </div>
                                        ) :
                                            (<div>
                                                <h4>Mendeteksi credential otomatis</h4>
                                                {this.state.responseLoginFailed}
                                                <div id="animation" style={{ width: "85%", display: "inline-flex" }}></div>
                                            </div>)
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getDataStudent: (dataTeacher, dataSchool) => dispatch(getDataStudent(dataTeacher, dataSchool))
    };
};

export default connect(null, mapDispatchToProps)(Login);